import { styled } from '@linaria/react';

export const Container = styled.div<{
	fullWidth?: boolean;
	selected?: boolean;
}>`
	position: relative;
	display: flex;
	gap: 4px;
	justify-content: center;
	align-items: center;
	padding: 8px 12px;
	width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
	min-width: 0;
	text-align: center;
	background-color: ${({ selected }) =>
		selected ? 'var(--color-black-06)' : 'var(--color-white-01)'};
	border: 2px solid;
	border-color: ${({ selected }) =>
		selected ? 'var(--bot-color-main)' : 'transparent'};
	border-radius: 12px;
	box-shadow: ${({ selected }) =>
		selected ? '0px 2px 18px 0px var(--bot-color-main)' : 'none'};
	transition: background-color 0.3s, border-color 0.3s, box-shadow 0.15s;
`;

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 15px;
`;

export const Label = styled.label`
	display: block;
	font-size: 15px;
	font-weight: 500;
	line-height: 20px;
	white-space: nowrap;
	text-align: center;
	cursor: pointer;

	&::after {
		content: '';
		position: absolute;
		left: -2px;
		top: -2px;
		width: calc(100% + 4px);
		height: calc(100% + 4px);
		border-radius: 12px;
	}
`;
